import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-12">
      <div className="max-w-3xl mx-auto space-y-6">
        <Link to="/" className="text-blue-600 hover:text-blue-800 text-sm">
          ← Volver
        </Link>

        <h1 className="text-3xl font-bold">
          Política de Tratamiento de Datos Personales
        </h1>
        <p className="text-sm text-gray-500">
          Última actualización: 23 de agosto de 2026
        </p>

        <p>
          CREATIMATICA S.A.S., identificada con NIT 902037926-7, con
          domicilio en Cl 12 6-46 Edf. Arminda Apt 202, Cúcuta, Norte de
          Santander, Colombia, representada legalmente por Jesús Mancilla, en
          su calidad de responsable del tratamiento de datos personales, pone
          a disposición de los titulares la presente Política de Tratamiento
          de Datos Personales, en cumplimiento de la Ley 1581 de 2012, su
          Decreto Reglamentario 1377 de 2013 (compilado en el Decreto Único
          Reglamentario 1074 de 2015) y la Ley 1266 de 2008 (Habeas Data),
          que regulan la protección de datos personales en Colombia.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Ámbito de aplicación</h2>
        <p>
          Aplica a los datos personales de usuarios, administradores,
          colaboradores de empresas clientes y demás titulares que
          interactúen con la plataforma Previonix ("la Plataforma"), un
          software como servicio (SaaS) para la gestión de equipos
          biomédicos, cronogramas de mantenimiento, órdenes de servicio,
          monitoreo ambiental IoT y reportes, dirigido a hospitales y
          clínicas.
        </p>

        <h2 className="text-xl font-semibold mt-8">
          2. Datos personales recolectados
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Datos de identificación: nombre completo, correo electrónico,
            cédula, teléfono, dirección, cargo.
          </li>
          <li>
            Datos de la empresa/cliente: razón social, NIT, dirección, datos
            de contacto.
          </li>
          <li>
            Datos sensibles de salud (ver sección 8): grupo sanguíneo, fecha
            de nacimiento, contacto y teléfono de emergencia, firma.
          </li>
          <li>
            Datos técnicos: dirección IP, tipo de dispositivo, navegador,
            tokens de sesión, tokens de notificaciones push (FCM).
          </li>
          <li>
            Datos operativos: información de equipos biomédicos,
            mantenimientos, órdenes de servicio, inventario, lecturas de
            sensores ambientales IoT.
          </li>
          <li>Datos de facturación: información de suscripción y planes.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          3. Finalidades del tratamiento
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Gestionar el registro, autenticación y administración de cuentas
            de usuario.
          </li>
          <li>
            Prestar los servicios funcionales de la Plataforma: gestión de
            inventario de equipos biomédicos, programación y ejecución de
            mantenimientos, órdenes de servicio, monitoreo ambiental y
            generación de reportes.
          </li>
          <li>
            Enviar notificaciones operativas (correo electrónico,
            notificaciones push) relacionadas con el servicio.
          </li>
          <li>
            Atender solicitudes, peticiones, quejas y reclamos (PQR) y
            brindar soporte técnico.
          </li>
          <li>Cumplir obligaciones legales, contractuales y regulatorias.</li>
          <li>
            Mejorar la Plataforma mediante análisis estadístico y
            funcionalidades de inteligencia artificial.
          </li>
          <li>
            Fines comerciales y de mercadeo, incluyendo el uso de píxeles de
            seguimiento en el sitio público, sujeto al aviso de cookies.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          4. Derechos de los titulares (Habeas Data)
        </h2>
        <p>
          De conformidad con el artículo 8 de la Ley 1581 de 2012, todo
          titular de datos personales tiene derecho a conocer, actualizar y
          rectificar sus datos; solicitar prueba de la autorización
          otorgada; ser informado sobre el uso dado a sus datos; presentar
          quejas ante la Superintendencia de Industria y Comercio (SIC);
          revocar la autorización y/o solicitar la supresión del dato cuando
          no exista un deber legal o contractual que lo impida; y acceder de
          forma gratuita a sus datos personales objeto de tratamiento.
        </p>

        <h2 className="text-xl font-semibold mt-8">
          5. Procedimiento para ejercer los derechos ARCO
        </h2>
        <p>
          El titular puede ejercer sus derechos de Acceso, Rectificación,
          Cancelación y Oposición (ARCO) enviando una solicitud al correo{" "}
          <a
            href="mailto:previonix@gmail.com"
            className="text-blue-600 underline"
          >
            previonix@gmail.com
          </a>
          , indicando nombre completo, documento de identidad, descripción
          clara de la solicitud y documentos que la soporten. CREATIMATICA
          S.A.S. dará respuesta dentro de los términos establecidos en el
          artículo 14 de la Ley 1581 de 2012 (15 días hábiles para consultas,
          10 días hábiles para reclamos, prorrogables según lo previsto en la
          norma).
        </p>

        <h2 className="text-xl font-semibold mt-8">
          6. Encargados del tratamiento y transferencia de datos
        </h2>
        <p>
          Para la correcta prestación del servicio, Previonix se apoya en
          proveedores tecnológicos que actúan como encargados del
          tratamiento: infraestructura y almacenamiento de archivos
          (Cloudflare R2), mensajería y notificaciones push (Firebase Cloud
          Messaging), inteligencia artificial para funcionalidades asistidas
          (OpenAI) y correo electrónico transaccional (SMTP). Estas
          transferencias y transmisiones internacionales de datos se
          realizan únicamente para los fines descritos en esta política.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Datos sensibles</h2>
        <p>
          Los campos de grupo sanguíneo, contacto de emergencia y fecha de
          nacimiento constituyen datos sensibles conforme al artículo 5 de la
          Ley 1581 de 2012. Su suministro es facultativo y no constituye
          requisito obligatorio para el uso de la Plataforma. El titular no
          está obligado a autorizarlos y su negativa no genera consecuencia
          adversa distinta a la imposibilidad de usar funcionalidades que
          dependan de dicha información.
        </p>

        <h2 className="text-xl font-semibold mt-8">
          8. Seguridad de la información
        </h2>
        <p>
          CREATIMATICA S.A.S. implementa medidas técnicas, humanas y
          administrativas razonables para proteger los datos personales
          contra pérdida, uso indebido, acceso no autorizado, alteración o
          divulgación, incluyendo cifrado de contraseñas, control de acceso
          basado en roles y permisos, y aislamiento de datos por empresa.
        </p>

        <h2 className="text-xl font-semibold mt-8">
          9. Tiempo de conservación
        </h2>
        <p>
          Los datos personales se conservarán mientras exista una relación
          contractual vigente con el titular o su empresa, y posteriormente
          durante el término requerido por las normas legales, contables,
          fiscales o regulatorias aplicables, o hasta que el titular solicite
          su supresión y no exista impedimento legal para ello.
        </p>

        <h2 id="cookies" className="text-xl font-semibold mt-8">
          10. Uso de cookies
        </h2>
        <p>
          La Plataforma utiliza cookies y tecnologías similares propias y de
          terceros (incluyendo píxeles de seguimiento con fines de mercadeo)
          para el funcionamiento del sitio. Al navegar en el sitio y aceptar
          el aviso de cookies, el usuario autoriza su uso conforme a esta
          política. Puede conocer más detalle sobre el tratamiento del dato
          asociado a cookies contactando al correo{" "}
          <a
            href="mailto:previonix@gmail.com"
            className="text-blue-600 underline"
          >
            previonix@gmail.com
          </a>
          .
        </p>

        <h2 className="text-xl font-semibold mt-8">
          11. Vigencia y modificaciones
        </h2>
        <p>
          Esta política rige a partir del 23 de agosto de 2026 y podrá ser
          modificada en cualquier momento. Los cambios sustanciales serán
          informados a los usuarios registrados, quienes deberán aceptar
          nuevamente la política actualizada para continuar usando la
          Plataforma.
        </p>

        <h2 className="text-xl font-semibold mt-8">12. Contacto</h2>
        <p>
          Para cualquier inquietud relacionada con el tratamiento de datos
          personales, puede escribir a{" "}
          <a
            href="mailto:previonix@gmail.com"
            className="text-blue-600 underline"
          >
            previonix@gmail.com
          </a>
          .
        </p>

        <div className="pt-6">
          <Link
            to="/tratamiento-datos"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Ver Autorización de Tratamiento de Datos →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
